<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{
                $l('tips_shipment_customer_setting_alter') || '订舱交期预警配置'
              }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="
                openEditFormDialog({
                  type: 'add',
                })
              "
              v-if="!disabled && shipmentCustomerSettingCode"
              ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:clearanceDuty="{ row }">
        <span>{{ row.clearanceDuty }}%</span>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
        >
          <i
            class="el-icon-edit tool-btn"
            @click="
              openEditFormDialog({
                type: 'edit',
                code: row.alertCode,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="del(row.alertCode)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="800px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
      append-to-body
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :alertCode="editFormDialogOptions.code"
        :shipmentCustomerSettingCode="shipmentCustomerSettingCode"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditForm from './edit-form'
export default {
  mixins: [EditLoading, TableAutoHeight],
  components: { EditForm },
  props: {
    disabled: { type: Boolean, default: false },
    shipmentCustomerSettingCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },

      tableColumns: tableColumns(this),

      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shipmentCustomerSettingCode) return
      this.loading = true
      this.$api
        .shipmentCustomerSettingAlertListApi({
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit:
          this.$l('dialog_title_settingalert_edit') || '编辑订舱交期预警配置',
        add: this.$l('dialog_title_settingalert_add') || '新增订舱交期预警配置',
        detail:
          this.$l('dialog_title_settingalert_detail') || '订舱交期预警配置详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentCustomerSettingAlertDelApi({
            alertCode: code,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>
